<template>
<div  v-show="kpi"
      v-bind:class="{ 
        pihead1: isHeader && showInlineYtd, 
        pihead2: isHeader && !showInlineYtd && !isStandalone, 
        ppgrid6: minorWaveCount === 5, 
        ppgrid5: minorWaveCount === 4, 
        ppgrid: minorWaveCount < 4 
      }">
      <div  class="perf-cell"
            v-for="index in minorWaveCount + 1">
        <div class="perf-block">
          <div class="perf-head left">{{ getName(index) }}</div>
          <div class="perf-value">{{ getStars(index) }}</div>
        </div>
      </div>

      <div class="perf-cell">
        <div class="pihead" v-bind:class="{ pigrid: isStandalone}">
          <div style="position: relative; text-align:right; padding-inline-end: 4px; top: 12px !important;">
            <span>
              <stars-score  style="font-size: 10pt; top: 8px;" 
                            :score="getStarsValue(kpi)"
                            :color="color" />
              <!-- <span style="font-weight: bold; color: black;">{{ getStarsValueText(kpi) }}</span> -->
            </span>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

  import ytdMixin from '@/mixins/YearToDateMixin.js';
  import StarCalculationMixin from '@/mixins/StarCalculationMixin.js';
  import StarsScore from './../StarsScore.vue';
  import PerformanceItemMixin from '@/mixins/bmw/PerformanceItemMixin.js';

  export default {
    mixins: [ ytdMixin, StarCalculationMixin, PerformanceItemMixin ],

    components:{
      'stars-score': StarsScore
    },

    props:{
      thresholds: { type: Array, required: true },
      color: { type: String, default: '#0066B1' }
    },

    methods: {
      getName(index) {
        const wave = this.getWave(index);
        return wave ? wave.Name.slice(2).replace("_", "") : undefined;
      },

      getWave(index) {
        if (!this.kpi || !this.kpi.SurveyWave)
          return undefined;

        const id = this.minorWaveCount + 1 === index ? 101 : index;
        return this.kpi.SurveyWave.find(x => x.Slot === id);
      },

      getStars(index) {
        const wave = this.getWave(index);
        return wave ? (5 * (wave.PointsReached / wave.PointsMax)).toFixed(1) : undefined;
      },
    }
  }

</script>

<style lang="scss" scoped>
  @import "@/../scss/bmw/performanceitem.scss";

  .minigrid {
    height: 33px;display: grid;
    grid-template-columns: 1fr 3fr;
  }

  .perf-cell {
    display: grid;
    margin: 0px;
    padding: 0px;
  }

  .perf-block{
    display: grid;
    height: 32px;
    margin: 0px;
    padding: 0px;
  }

  .perf-head {
    display: grid;
    position: relative;
    margin: 0px;
    padding: 0px;
  }

  .perf-value {
    display: grid;
    position: relative;
    height: 50%;
  }

  .image {
    top: -30px;
    right: -35px;
  }

  .card-body {
    padding: 0pt;
  }

  .bc-header {
    padding: 0pt;
    margin: 0pt;
    align-self: auto;
  }

  .card-header {
    padding: 0pt;
    margin: 0pt;
    align-self: auto;
  }

  .table {
    padding: 0pt;
    margin: 0pt;
  }
  .ppgrid, .ppgrid5, .ppgrid6, .perf-block {
  display: grid;
  height: 36px;
}
.ppgrid {
  grid-template-columns: 2fr 2fr 2fr 2fr 5fr;
}

.ppgrid5 {
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 6.25fr;
}

.ppgrid6 {
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr 7.5fr;
}

</style>
